module.exports = __webpack_public_path__ + "assets/img/small_ointment_icon.20fda3b5.svg";